import { Table, TableBody, TableContainer } from "@mui/material";

import { OrderSearchOut } from "@providers/hop-ord-server/api";

import DosiTableHeader from "@pages/CommandCenter/CommandCenterTable/Rows/DosiTableHeader";
import DosiTableRow from "@pages/CommandCenter/CommandCenterTable/Rows/DosiTableRow";
import NoResultsRow from "@pages/CommandCenter/CommandCenterTable/Rows/NoResultsRow";
import RoTableHeader from "@pages/CommandCenter/CommandCenterTable/Rows/RoTableHeader";
import RoTableRow from "@pages/CommandCenter/CommandCenterTable/Rows/RoTableRow";

interface Props {
  data: OrderSearchOut[] | undefined;
  isLoading: boolean;
  noResultsMessage: string;
  toolTips: string[];
  isRo: boolean;
}

const CommandCenterTable = ({
  data,
  isLoading,
  noResultsMessage,
  toolTips,
  isRo,
}: Props) => {
  const showNoResults = !data?.length || isLoading;

  return (
    <TableContainer
      sx={{
        flexGrow: 1,
        overflow: "auto",
        height: 1,
        maxHeight: "calc(100vh - 250px)",
      }}
    >
      <Table
        stickyHeader
        size="small"
        sx={{
          minWidth: "1350px",
          "& .MuiTableCell-head": {
            backgroundColor: "grey.100",
          },
          "& .MuiTableCell-body": {
            padding: isLoading ? 0 : 2,
          },
        }}
      >
        {isRo ? (
          <>
            <RoTableHeader />
            {
              <TableBody>
                {showNoResults ? (
                  <NoResultsRow
                    colSpan={7}
                    isLoading={isLoading}
                    noResultsMessage={noResultsMessage}
                    toolTips={toolTips}
                  />
                ) : (
                  data?.map((order, index) => {
                    return (
                      <RoTableRow key={order.id} order={order} index={index} />
                    );
                  })
                )}
              </TableBody>
            }
          </>
        ) : (
          <>
            <DosiTableHeader />
            <TableBody>
              {showNoResults ? (
                <NoResultsRow
                  colSpan={7}
                  isLoading={isLoading}
                  noResultsMessage={noResultsMessage}
                  toolTips={toolTips}
                />
              ) : (
                data?.map((order, index) => {
                  return (
                    <DosiTableRow key={order.id} order={order} index={index} />
                  );
                })
              )}
            </TableBody>
          </>
        )}
      </Table>
    </TableContainer>
  );
};

export default CommandCenterTable;
